
import { Component, Mixins, VModel, Watch } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'

import MixinInterface from '@/_mixins/index'
import ProjectMixin from '@/_mixins/project'

import { searchProjects } from '@/utils/project'

@Component({
    mixins: [ProjectMixin],
    inheritAttrs: false,
})
export default class ProjectsAutocomplete extends Mixins<MixinInterface>(ProjectMixin) {
    @VModel({ required: true }) items!: Array<Record<string, any>>

    searchTerm = ''
    isLoading = false
    isLoaded = false
    projects: Array<Record<string, any>> = []
    isDirty = false
    offset = 0
    limit = 10
    infiniteId = crypto['randomUUID']()

    initialAutocomplete() {
        this.isDirty = true
        this.initSearch()
    }

    @Watch('searchTerm')
    initLoading() {
        this.isLoading = true
        this.offset = 0
    }

    @Debounce(600)
    @Watch('searchTerm')
    async initSearch() {
        this.isLoaded = false
        this.projects = []
        this.infiniteId = crypto['randomUUID']()
        await this.search()

        this.isLoading = false
    }

    async search($state = null as any) {
        if (!this.isDirty) return

        try {
            this.isLoading = true
            let params = {
                ...(this.searchTerm?.trim().length > 1 && {
                    'filter[searchTerm]': this.searchTerm,
                }),
                'page[offset]': this.offset,
                'page[limit]': this.limit,
            }
            const newProjects = await searchProjects(params)

            this.offset += this.limit

            // Prevent infinit loading if all the result are loaded
            if (newProjects.length < this.limit) {
                this.isLoaded = true
            }

            if ($state) {
                if (newProjects.length == this.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }

            this.projects = [...this.projects, ...newProjects]
        } finally {
            this.isLoading = false
        }
    }

    setInitialValues() {
        this.projects = this.items
    }
}
